import { SelectOptions } from "@/types/snap-ui";

export const Languages: SelectOptions = [
  { name: "English", value: "en" },
  { name: "Spanish", value: "es" },
];

export const languageName = (value: string): string =>
  Languages.find((language) => language.value === value)?.name || "Unknown";
